import React, { useEffect, useState } from 'react';
import { MenuIcon } from 'lucide-react';
interface HeaderProps {
  onOpenMenu: () => void;
}
export function Header({
  onOpenMenu
}: HeaderProps) {
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <header className={`fixed top-0 left-0 right-0 z-40 h-20 transition-colors duration-500 ease-in-out flex items-center justify-between px-6 md:px-12 ${isScrolled ? 'bg-charcoal shadow-lg' : 'bg-transparent'}`} data-id="element-115">
      {/* Logo */}
      <div className="z-50" data-id="element-116">
        <a href="#" className="text-gold font-bold text-2xl tracking-widest uppercase hover:text-white transition-colors duration-300" data-id="element-117">
          Glenlofty
        </a>
      </div>

      {/* Hamburger Trigger */}
      <button onClick={onOpenMenu} className="group flex items-center justify-center p-2 focus:outline-none" aria-label="Open Menu" data-id="element-118">
        <div className="relative w-10 h-10 flex items-center justify-center" data-id="element-119">
          <MenuIcon className="w-8 h-8 text-gold transition-transform duration-300 group-hover:scale-110" data-id="element-120" />
        </div>
      </button>
    </header>;
}